import React from "react";
import { isEqual } from "lodash";
import { withTranslation } from "react-i18next";

const Chartist = process.browser && require("chartist");

const BASE_OPTIONS = {
  donut: true,
  donutSolid: true,
  donutWidth: "15%",
  height: 250,
  ignoreEmptyValues: false,
  showLabel: false,
  width: "100%",
};

class NutrientsChartForWidget extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    require("chartist-plugin-fill-donut");
    const { data, donutContent } = this.generateChartData();
    const { height } = this.props;
    if (height) {
      BASE_OPTIONS.height = height;
    }

    const options = Object.assign({}, BASE_OPTIONS, {
      plugins: [
        Chartist.plugins.fillDonut({
          items: [
            {
              content: donutContent,
            },
          ],
        }),
      ],
    });

    this.chartObject = new Chartist.Pie(".donut-chart", data, options);
  }

  componentDidUpdate(prevProps) {
    if (
      !isEqual(prevProps.dayStats, this.props.dayStats) ||
      !isEqual(prevProps.nutritionPlan, this.props.nutritionPlan)
    ) {
      this.updateChart();
    }
  }

  getNutrientsData() {
    const { dayStats, nutritionPlan } = this.props;
    const { carbs = 0, fats = 0, proteins = 0 } = dayStats.nutrients;
    const target = nutritionPlan || { calories: 0 };

    const proteinsKcal = Math.round(proteins * 4);
    const carbsKcal = Math.round(carbs * 4);
    const fatsKcal = Math.round(fats * 9);
    const calories = Math.round(proteinsKcal + carbsKcal + fatsKcal);
    const caloriesLeft = Math.round(target.calories - calories);

    const proteinPercent = Math.round((proteinsKcal / calories) * 100) || 0;
    const carbsPercent = Math.floor((carbsKcal / calories) * 100) || 0;
    const fatPercent = Math.round((fatsKcal / calories) * 100) || 0;

    return {
      proteinsKcal,
      carbsKcal,
      fatsKcal,
      calories,
      caloriesLeft,
      proteinPercent,
      carbsPercent,
      fatPercent,
    };
  }

  generateChartData() {
    const { nutritionPlan, t } = this.props;
    const { proteinsKcal, carbsKcal, fatsKcal, calories, caloriesLeft } =
      this.getNutrientsData();

    const overLabel = t("nutritionPage.donut.over");
    const leftLabel = t("nutritionPage.donut.left");
    const kcalLabel = t("nutritionPage.donut.kcal");

    const data = {
      series: [
        { value: proteinsKcal, className: "proteins" },
        { value: carbsKcal, className: "carbs" },
        { value: fatsKcal, className: "fats" },
      ],
    };

    const targetCalories = nutritionPlan
      ? `<span class="kcal-target">/${nutritionPlan.calories}</span>`
      : "";
    const left = nutritionPlan
      ? `
          <div>
            <span class="kcal-left${caloriesLeft < 0 ? " over" : ""}">
              ${Math.abs(caloriesLeft)} ${caloriesLeft < 0 ? overLabel : leftLabel}
            </span>
          </div>
        `
      : "";

    const donutContent = `
    <div class="donut-content">
      <div>
        <span class="kcal-value">${calories}</span>
        ${targetCalories}
      </div>

      <div class="kcal-label">${kcalLabel}</div>
      ${left}
    </div>`;

    return { data, donutContent };
  }

  updateChart() {
    const { data, donutContent } = this.generateChartData();
    const options = Object.assign({}, BASE_OPTIONS, {
      fillDonutOptions: { items: [{ content: donutContent }] },
    });
    this.chartObject.update(data, options);
  }

  renderLegend() {
    const { t } = this.props;
    const { proteinPercent, carbsPercent, fatPercent } =
      this.getNutrientsData();

    return (
      <div style={{ flex: 1 }} className="direction-legend legend-container">
        {!!proteinPercent && (
          <div className="legend-item">
            <div className="legend-indicator protein" />
            <span>{t("nutritionPage.donut.proteinPercent", { percent: proteinPercent })}</span>
          </div>
        )}
        {!!carbsPercent && (
          <div className="legend-item">
            <div className="legend-indicator carbs" />
            <span>{t("nutritionPage.donut.carbsPercent", { percent: carbsPercent })}</span>
          </div>
        )}
        {!!fatPercent && (
          <div className="legend-item">
            <div className="legend-indicator fat" />
            <span>{t("nutritionPage.donut.fatPercent", { percent: fatPercent })}</span>
          </div>
        )}
      </div>
    );
  }

  render() {
    return (
      <div className="chart-widget-section graph-container donut">
        <div
          style={{ flex: 1.5, height: "fit-content" }}
          className="donut-chart"
        />
        {this.renderLegend()}
      </div>
    );
  }
}

export default withTranslation("athlete-portal")(NutrientsChartForWidget);
